<template>
  <v-container class="py-5" fluid>
    <h1>Help Desk</h1>
    <v-divider class="my-7"/>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <AddTrade/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <RegisterToTournament/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <TournamentParticipants/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddTrade from "@/views/HelpDesk/components/AddTrade";
import RegisterToTournament from "@/views/HelpDesk/components/RegisterToTournament";
import TournamentParticipants from "@/views/HelpDesk/components/TournamentParticipants";

export default {
  name: "HelpDesk",
  components: {TournamentParticipants, RegisterToTournament, AddTrade},
  data() {
    return {

    };
  },
}
</script>

<style scoped>

</style>
